// extracted by mini-css-extract-plugin
module.exports = {"lds-ellipsis":"style_lds-ellipsis__1s8PP","lds-ellipsis1":"style_lds-ellipsis1__1CUBe","lds-ellipsis2":"style_lds-ellipsis2__3awbO","lds-ellipsis3":"style_lds-ellipsis3__3f-Ae"};